import { Paper } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';

interface SectionCardProps {
  children: ReactNode;
  error?: boolean;
  sx?: SxProps<Theme>;
}

export function SectionCard({ children, error, sx }: SectionCardProps) {
  return (
    <Paper
      variant="outlined"
      sx={[
        {
          flex: 1,
          overflow: 'hidden',
          p: 2,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
        // Last so a caller's sx cannot silently drop the validation-error border.
        !!error && {
          borderColor: 'error.main',
          borderWidth: 2,
        },
      ]}
    >
      {children}
    </Paper>
  );
}

export default SectionCard;
